export default {
    autoCue: (state) => {
        return state.autoCue
    },
    activeWorkout: (state) => {
        return state.activeWorkout
    },
    cueItems: (state) => {
        return state.cueItems
    },
    cueWithRestItems: (state) => {
        return state.cueWithRestItems
    },
    scriptOpened: (state) => {
        return state.opened
    },
    hasCircuits: (state) => {
        return state.circuits.length > 0
    },
    hasMoreThanOneCircuits: (state) => {
        return state.circuits.length > 1
    },
    circuits: (state) => {
        return state.circuits
    },
    selectedMoves: (state) => {
        return state.selectedMoves
    },
    hasSelectedMoves(state) {
        return state.selectedMoves.length > 0
    },
    hasMoreThanOneSelectedMoves(state) {
        return state.selectedMoves.length > 1
    },
    hasSelectedCircuits(state) {
        return state.selectedCircuits.length > 0
    },
    hasPendingMoves(state) {
        let hasEdit = false
        for (let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            for (let j=0;j<currentCircuit.items.length;j++) {
                const currentItem = currentCircuit.items[j]
                if (!currentItem.confirmed){
                    hasEdit = true
                    break
                }
                if (currentItem.type === 'round') {
                    for (let k=0;k<currentItem.items.length;k++) {
                        const currentItemRound = currentItem.items[k]
                        if (!currentItemRound.confirmed){
                            hasEdit = true
                            break
                        }
                    }
                }
            }
        }
        return hasEdit
    },
    isPreviousCircuitEmpty(state){
         
            if(state.circuits.length){
                return state.circuits[state.circuits.length-1].items.length == 0
            }
            return false
        
    },
    sortedMove: (state) => {
        const newList = []
        let order = 1
        for (let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            for (let j=0;j<currentCircuit.items.length;j++) {
                const currentItem = currentCircuit.items[j]
                if (!currentCircuit.items[j]){
                    continue
                }
                if (currentItem.type === 'move') {
                    newList.push({
                        id: currentItem.id,
                        order,
                    })
                    order += 1
                }
                else if (currentItem.type === 'round') {
                    for (let k=0;k<currentItem.items.length;k++) {
                        const currentItemRound = currentItem.items[k]
                        if (currentItemRound.type === 'move') {
                            newList.push({
                                id: currentItemRound.id,
                                order,
                            })
                            order += 1
                        }
                    }
                }
            }
        }
        return newList
    },
    itemOrdering: (state) => {
        const newList = []
        for (let i=0;i<state.circuits.length;i++) {
            const currentCircuit = state.circuits[i]
            for (let j=0;j<currentCircuit.items.length;j++) {
                const currentItem = currentCircuit.items[j]
                if (!currentCircuit.items[j]){
                    continue
                }
                newList.push({
                    id: currentItem.id,
                    order: currentItem.order
                })
                if (currentItem.type === 'round') {
                    for (let k=0;k<currentItem.items.length;k++) {
                        const currentItemRound = currentItem.items[k]
                        newList.push({
                            id: currentItemRound.id,
                            order: currentItemRound.order,
                        })
                    }
                }
            }
        }
        return newList
    },
    cueWithRestItemsWithCircuit: (state) => {
        return state.cueWithRestItemsWithCircuit
    },
    renderList: (state) => {
        return state.render
    }
}